import { TemplateTransferTableProps, TransferItem } from '@/template/interface'
import { getFormatMessage, mergeTableColumns } from '@/utils/utils'
import { Table } from 'antd'
import React from 'react'

export const TemplateTransferTable: React.FC<TemplateTransferTableProps> = (
  props: TemplateTransferTableProps
) => {
  const formatMessage = getFormatMessage()
  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.template.transfer.table.index' }),
      key: 'app.template.transfer.table.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.template.transfer.table.name' }),
      key: 'app.template.transfer.table.name',
      render: (text: any, record: TransferItem, index: any) =>
        record.server_config?.config_name
    },
    {
      title: formatMessage({ id: 'app.template.transfer.table.host' }),
      key: 'app.template.transfer.table.host',
      render: (text: any, record: TransferItem, index: any) => {
        return `${record.server_config?.server_url}:${record.server_config?.server_port}`
      }
    },
    {
      title: formatMessage({ id: 'app.template.transfer.table.pubMode' }),
      key: 'app.template.transfer.table.pubMode',
      render: (text: any, record: TransferItem, index: any) => {
        return record.server_config?.pub_mode === 'interval'
          ? formatMessage({ id: 'app.mqtt.pubMode.interval' })
          : formatMessage({ id: 'app.mqtt.pubMode.changed' })
      }
    },
    {
      title: formatMessage({ id: 'app.template.transfer.table.enable' }),
      key: 'app.template.transfer.table.enable',
      render: (text: any, record: TransferItem, index: any) => {
        return record.enable ? '是' : '否'
      }
    }
  ]
  const columns = mergeTableColumns(defaultColumns, props.columns)

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
    />
  )
}
